import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ColumnChart from "../../components/Charts/ColumnChart";
import Loader from "react-js-loader";
import MainError from "../../components/Notifications/MainError";
import { changeNot } from "../../store/urlSlice";
import usePrivate from "../../store/useAxiosPrivate2";
function Recevable() {
  const { sendRequest } = usePrivate();
  const { t } = useTranslation();
  const BackUpType = useSelector(state => state.auth.backUpType);
  const [db, setdb] = useState(null);
  const [type, setType] = useState("chart");
  const dispatch = useDispatch();
  const notification = useSelector(state => state.url.notification);
  const selectedCompany = useSelector(state => state.auth.selectedCompany);
  const currency = useSelector(state => state.auth.currency);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await sendRequest(
          "GET",
          `GetData/Income/${selectedCompany}/${BackUpType}`,
          null
        );

        dispatch(changeNot({ type: res.isSuccess, message: res.message }));
        setdb(res);
      } catch (err) {
        console.error(err);
        dispatch(changeNot({ type: err.isSuccess, message: err.message }));
        console.log(err);
      }
    };

    fetchData();
  }, [BackUpType, selectedCompany]);

  return db !== null ? (
    db.isSuccess ? (
      db.result.income.length > 0 ? (
        <div className="cash-detail">
          <div className="cash-head">
            <h3>
              {t("Dovr")}:{" "}
              {db.isSuccess
                ? db.result[`total${currency.text}`].toLocaleString("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                : 0}{" "}
              <i className={currency.icon}></i>
            </h3>
            <ul className="show-type">
              <li
                className={type !== "table" ? "active" : "hide"}
                onClick={() => setType("table")}
              >
                <span>{t("Cədvəlgörünüşü")}</span>
                <i className="fa-solid fa-bars"></i>
              </li>
              <li
                className={type !== "chart" ? "active" : "hide"}
                onClick={() => setType("chart")}
              >
                <span>{t("Qrafikgörünüşü")}</span>
                <i className="fa-solid fa-chart-line"></i>
              </li>
            </ul>
          </div>
          <div className="area w-100">
            {type === "chart" ? (
              <ColumnChart
                data={db.result.income.map(item => {
                  const totalAmount = item.rows.reduce(
                    (acc, row) => acc + row[`amount${currency.text}`],
                    0
                  );
                  return {
                    x: item.date,
                    y: totalAmount.toLocaleString("tr-TR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }),
                  };
                })}
                color={"#6ec599"}
                height="100%"
                toolbar={true}
                labelx={true}
                labely={true}
                icon={currency.id === 1 ? "₼" : currency.id === 3 ? "$" : "€"}
              />
            ) : (
              <table className="table">
                <tbody>
                  {[...db.result.income].reverse().map((d, i) => {
                    return (
                      <React.Fragment key={i}>
                        <tr className="date-row">
                          <td colSpan={3}>
                            {d.date} -{" "}
                            {d[`sum${currency.text}`].toLocaleString("tr-TR", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                            <i className={currency.icon}></i>
                          </td>
                        </tr>
                        {d.rows.map((row, j) => {
                          return (
                            <tr key={j}>
                              <td>{row.costumer}</td>
                              <td>{row.contract}</td>
                              <td className="textal">
                                {row[`amount${currency.text}`].toLocaleString(
                                  "tr-TR",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                                <i className={currency.icon}></i>
                              </td>
                            </tr>
                          );
                        })}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>
      ) : (
        <div style={{ padding: "45px 13px" }}>
          <h2 className="section-head" style={{ marginLeft: "20px" }}>
            {t("Məlumatyoxdur")}
          </h2>
        </div>
      )
    ) : (
      <div style={{ padding: "45px 13px" }}>
        <h2 className="section-head" style={{ marginLeft: "20px" }}>
          {t("Məlumatyoxdur")}
        </h2>
        {notification ? <MainError /> : null}
      </div>
    )
  ) : (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Loader
        type="box-rectangular"
        bgColor={"#0d2e4e"}
        color={"#0d2e4e"}
        title={"REPORTO"}
        size={80}
      />
    </div>
  );
}

export default Recevable;
